import { SEGMENT } from '../../config';
import AppError from '../../errors/apperror';
import Logger from '../../logger/logger';
import ERRORS from '../../errors/errorids';
import _ from 'lodash';
import { getSubscriptionsAndAddons, hasDesktopSubscription } from '../../utils/subscription';
const log = Logger.get('segment');

let xaraTrackingId;

const sendToAnalyticsAndAmplitudeOptions = {
	integrations: {
		'All': false,
		'Google Analytics': true,
		'Google Analytics 4 Web': true,
		'Amplitude': true
	}
};

const sendToGA4Options = {
	integrations: {
		'All': false,
		'Google Analytics 4 Web': true
	}
};

const excludeAmplitudeOptions = {
	integrations: {
		'All': true,
		'Amplitude': false
	}
};

const allDestinationsOptions = {
	integrations: {
		'All': true
	}
};

export const setTrackingId = (trackingId) => {
	xaraTrackingId = trackingId;
};

export const identify = (attributes, options) => { // eslint-disable-line
	if (!SEGMENT) return;
	if (xaraTrackingId) {
		try {
			window.analytics.identify(
				xaraTrackingId,
				attributes,
				options
			);
		} catch (err) {

			log.send(new AppError({
				message: 'Segment.identify() failed',
				errorId: ERRORS.UNKNOWN,
				originalError: err,
				visualisers: { feature: 'SEGMENT' }
			}));

			console.error('Couldn\'t identify event to Segment', event, data);  // eslint-disable-line
		}
	} else {
		log.send(new AppError({
			message: 'xaraTrackingId not found',
			errorId: ERRORS.UNKNOWN,
			visualisers: { feature: 'SEGMENT' }
		}));

		console.error('Missing Xara tracking id');  // eslint-disable-line
	}
};

export const track = (event, data, options) => {
	if (!SEGMENT) return;
	try {
		window.analytics.track(event, data, options);

		// If event contains dash it will be rejected in GA4 property so send it with underscore again
		if (event.indexOf('-') !== -1) {
			window.analytics.track(event.replace(/-/g, '_'), data, sendToGA4Options);
		}

	} catch (err) {
		log.send(new AppError({
			message: 'Segment.track() failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'SEGMENT' }
		}));

		console.error('Couldn\'t track event to Segment', event, data);  // eslint-disable-line
	}
};

export const trackEcommerceData = (event, data) => {
	if (!SEGMENT) return;
	try {
		window.analytics.track(event, data, sendToAnalyticsAndAmplitudeOptions);
	} catch (err) {
		log.send(new AppError({
			message: 'trackEcommerceDataFailed failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'SEGMENT' }
		}));

		console.error('Couldn\'t track event to Segment', event, data);  // eslint-disable-line
	}
};

export const trackConfiguratorQuantity = (quantityType, value, options) => {
	if (!SEGMENT) return;

	try {
		const eventName = `cap-change-quantity-${quantityType}-${value}`;

		let trackDestination;
		if (_.get(options, 'integrations.Amplitude') === false) {
			trackDestination = sendToGA4Options;
		} else {
			trackDestination = sendToAnalyticsAndAmplitudeOptions;
		}

		window.analytics.track(eventName, null, trackDestination);
		window.analytics.track(eventName.replace(/-/g, '_'), null, sendToGA4Options);
	} catch (err) {
		log.send(new AppError({
			message: 'trackConfiguratorQuantity failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'SEGMENT' }
		}));

		console.error('Couldn\'t track event to Segment', event, data);  // eslint-disable-line
	}	
};


export const trackReducedUsersData = (nrOfUsersToTurnToGuest, nrOfUsersToDelete, options) => {
	if (!SEGMENT) return;

	try {
		const eventName = `cap-reduced-users-${nrOfUsersToTurnToGuest}-to-guests-${nrOfUsersToDelete}-deleted`;

		let trackDestination;
		if (_.get(options, 'integrations.Amplitude') === false) {
			trackDestination = sendToGA4Options;
		} else {
			trackDestination = sendToAnalyticsAndAmplitudeOptions;
		}

		window.analytics.track(eventName, null, trackDestination);
		window.analytics.track(eventName.replace(/-/g, '_'), null, sendToGA4Options);
	} catch (err) {
		log.send(new AppError({
			message: 'trackReducedUsersData failed',
			errorId: ERRORS.UNKNOWN,
			originalError: err,
			visualisers: { feature: 'SEGMENT' }
		}));

		console.error('Couldn\'t track event to Segment', event, data);  // eslint-disable-line
	}
};

export const getTrackingOptions = (company) => {
	const isDesktopMagix = _.get(company, 'marketingTags.desktop-magix');
	const isXaraDesktopOrigin = _.get(company, 'marketingTags.xara-desktop-origin');

	let { perpetualAddons } = getSubscriptionsAndAddons(company);

	const activeDesktopSubscription = hasDesktopSubscription(company);
	
	const hasPerpetualPlan = !_.isEmpty(perpetualAddons);
	const isDesktopCompanySelected = hasPerpetualPlan || activeDesktopSubscription || isDesktopMagix || isXaraDesktopOrigin;

	return isDesktopCompanySelected && !company.hasUnlimitedTeamSubscription ? excludeAmplitudeOptions : allDestinationsOptions;
};


// WEBPACK FOOTER //
// ./src/lib/Segment/helpers.js